module.exports = __webpack_public_path__ + "static/media/icon-instagram.d064bd6e.webp";